import { Box, Collapse } from '@mui/material';
import { useState, type FC } from 'react';
import { useSelector } from '@/store';
import { useActiveGateMovements } from '@features/gateCommon/hooks/useActiveGateMovements';
import { LegacyMovementRow } from './gateMovementBanner/LegacyMovementRow';
import { V2MovementRow } from './gateMovementBanner/V2MovementRow';

/**
 * Banner global de compuertas en movimiento: las del sistema legacy (store) y las v2
 * (`activeGateMovements`, AMARU-911). Ninguna compuerta tiene datos en ambos sistemas.
 */
const GateMovementBanner: FC = () => {
  const { gatesInMovement } = useSelector((state) => state.gates_in_movement_store);
  const activeMovements = useActiveGateMovements();
  const [collapsed, setCollapsed] = useState(false);

  const rows = [
    ...gatesInMovement.map((gateInMovement) => ({ source: 'legacy' as const, gateInMovement })),
    ...activeMovements.map((movement) => ({ source: 'v2' as const, movement })),
  ];

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'warning.main',
        color: 'black',
        textAlign: 'center',
      }}
    >
      <Collapse collapsedSize={rows.length === 0 ? 0 : 25} in={!collapsed}>
        {rows.map((row, index) => {
          const position = {
            index,
            isLast: index === rows.length - 1,
            collapseToggle:
              rows.length > 1 && index === 0
                ? { collapsed, onToggle: () => setCollapsed(!collapsed) }
                : null,
          };
          return row.source === 'legacy' ? (
            <LegacyMovementRow
              key={`legacy-${row.gateInMovement.gateId}`}
              gateInMovement={row.gateInMovement}
              {...position}
            />
          ) : (
            <V2MovementRow key={`v2-${row.movement.id}`} movement={row.movement} {...position} />
          );
        })}
      </Collapse>
    </Box>
  );
};

export default GateMovementBanner;
